module.exports = __webpack_public_path__ + "img/default-nav-subnav-mazda.cf7d988a.png";